const checkExtension = (extensions, fileName) => {
  let allowedExtensions = extensions.split(',').map(value => value.trim()).filter(value => value);
  allowedExtensions = new RegExp(`\\.(${ allowedExtensions.join('|').replace(/\./g, '\\.') })$`, 'i');

  return !(fileName.search(allowedExtensions) === -1);
};

export default checkExtension;
